import {Component} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {Md5} from 'ts-md5';

import { NavService } from 'shared/nav/nav.service';
import {LoginService} from 'app/login/services/login.service';

import { Browser } from '@capacitor/browser';
import { UserService } from 'app/profile/services/user.service';
import { UserProfile } from 'app/profile/model/model';

@Component({
  selector: 'account-page',
  templateUrl: 'account-page.html',
  styleUrls: ['account-page.scss'],
})
export class AccountPage {

  constructor(
    public navService: NavService,
    private loginService: LoginService,
    private userService: UserService,
    private translateService: TranslateService,
  ) { }

  public showPasswordSetPage(): void {
    this.navService.push('profile/passwordset');
  }

  public logout(): void {
    this.loginService.logout().subscribe((success) => {
      this.navService.root('login', {autoLogin: false});
    });
  }

  public unregister(): void {
    this.userService.getUserProfile('full')
    .subscribe((profile: UserProfile) => {
      Browser.open({url: 'https://register.leada.de/unregister/'+profile.email+'?code='+Md5.hashStr(profile._id)+'&lang='+this.translateService.currentLang});
    });
  }
}
